import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import currencyFormat from 'functions/currencyFormat'

import Button from 'components/Button'
import QuoteWrapper from 'agency/digital_renderer/components/QuoteWrapper'

import QuoteSection from './QuoteSection'
import styles from './styles.scss'

const downloadLink = (link) => {
  const { pathname } = window.location
  const shareLinkMatch = pathname.match(/\/share\/([\w-]+)/)

  if (shareLinkMatch){
    return `${link}?share_link_token=${shareLinkMatch[1]}`
  }

  return link
}

const Quote = (props) => {
  const {
    brand: { colour_primary, colour_highlight },
    campaignQuote,
  } = props

  return (
    <QuoteWrapper
      campaignQuote={campaignQuote}
      render={({ quoteSections }) => (
        <div className={styles.root}>
          {quoteSections.map(section => <QuoteSection key={section.id} campaignQuoteSection={section} />)}

          <div className={styles.footer}>
            {campaignQuote.links && (
              <Button
                href={downloadLink(campaignQuote.links.pdf)}
                icon={<FontAwesomeIcon icon={faDownload} />}
                style={{
                  color: `#${colour_highlight}`,
                  backgroundColor: `#${colour_primary}`,
                  borderColor: `#${colour_primary}`,
                }}
                text="Download Quote"
              />
            )}

            <div className={styles.right}>
              <span className={styles.total}>{currencyFormat(campaignQuote.total)}</span>
            </div>
          </div>
        </div>
      )}
    />
  )
}

Quote.propTypes = {
  brand: PropTypes.object.isRequired,
  campaignQuote: PropTypes.object.isRequired,
}

export default Quote
